import { IconBriefcase, IconCalendar } from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";
import moment from "moment";

export default function ExperienceCard({ experiences }) {
  return (
    <Card
      icon={IconBriefcase}
      title="Work Experience"
      subtitle={`${experiences?.length} positions`}
    >
      {experiences?.map((item, i) => (
        <div className={styles.expItem} key={i}>
          <div className={styles.expRail}>
            {item?.current ? (
              <span className={`${styles.expDate} ${styles.expDateNow}`}>
                Current
              </span>
            ) : (
              <span className={styles.expDate}>
                {item?.endDate ? moment(item?.endDate).format("MMM yyyy") : ""}
              </span>
            )}
            <span
              className={`${styles.expDot} ${!item?.isCurrentJob ? styles.expDotEnd : ""}`}
            />
            {i < experiences?.length - 1 && (
              <>
                <span className={styles.expLine} />
                <span className={styles.expDate}>
                  {moment(item?.startDate).format("MMM yyyy")}
                </span>
              </>
            )}
          </div>
          <div>
            <div className={styles.expTitle}>
              <IconBriefcase size={17} /> {item?.jobTitle}
            </div>
            <div className={styles.expCompany}>{item?.companyName}</div>
            <div className={styles.expIndustry}>
              <b>Industry</b>
              <span className={styles.sep}>|</span>
              {item?.industry}
            </div>
            <span className={styles.expPeriod}>
              <IconCalendar size={13} />{" "}
              {moment(item?.startDate).format("MMM yyyy")} -{" "}
              {item?.isCurrentJob
                ? "Present"
                : moment(item?.endDate).format("MMM yyyy") || ""}
            </span>
            <p className={styles.expDesc}>{item?.jobDescription}</p>
          </div>
        </div>
      ))}
    </Card>
  );
}
